// extracted by mini-css-extract-plugin
module.exports = {"header":"BrowserContent_header__318K5","content":"BrowserContent_content__1jHtm"};